import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, number, object, string } from "yup";
import { type AssetAllocationFields, createAssetAllocationSchema } from "../helpers";

export type InvestmentsFormType = AssetAllocationFields & {
  readonly investmentToolType: string;
  readonly partner?: string;
  readonly product?: string;
  readonly oneTimeDeposit: number;
  readonly regularAmount: number;
  readonly horizon: number;
  readonly appreciationRate: number;
  readonly entryFee?: number;
  readonly oneTimeFee?: number;
  readonly managementFee?: number;
  readonly exitFee?: number;
  readonly note?: string;
};

export const getInvestmentsFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
  requireCharacteristics?: boolean,
  minRegularAmount?: number,
) => ObjectSchema<InvestmentsFormType> = (t, requireCharacteristics, minRegularAmount) => {
  return object({
    investmentToolType: string().required(t(Resources.Validation.Required)),
    partner: string().optional(),
    product: string().optional(),
    oneTimeDeposit: number().required(t(Resources.Validation.Required)),
    regularAmount: minRegularAmount
      ? number()
          .required(t(Resources.Validation.Required))
          .test(
            "zero-or-more-than-min",
            t(Resources.Validation.Number.ZeroOrMoreThan, { count: minRegularAmount }),
            (value) => value === 0 || value >= minRegularAmount,
          )
      : number().required(t(Resources.Validation.Required)),
    horizon: number().required(t(Resources.Validation.Required)),
    appreciationRate: number().required(t(Resources.Validation.Required)),
    entryFee: number().optional(),
    oneTimeFee: number().optional(),
    managementFee: number().optional(),
    exitFee: number().optional(),
    ...createAssetAllocationSchema(t, requireCharacteristics),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
  }).defined();
};
